import { AccountBalanceWallet, LocalShippingSharp } from "@mui/icons-material";
import {
  Box,
  Grid,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import { NoteAddIcon } from "../../../common/iconsData";
import { Card } from "../../ui/Card";
import styled from "styled-components";

import { useOverview } from "./dashboardApi";
import { NoDataFound } from "../../../common/NoDataFound";
import { tableCellStyle } from "./Shipment";

const SmallBox = styled.div`
  padding: 10px;
  background-color: #dadada;
  border-radius: 10px;
  min-width: 40px;
  text-align: center;
  margin-bottom: 4px;
`;

const Overview = () => {
  const { data: dashboardData } = useOverview();
  // const username = localStorage.getItem("hipship-username") || "User";
  // const isUser = username === "Cipla";

  return (
    <>
      <Grid container spacing={2}>
        <Grid item sm={12} xs={12} md={12}>
          <Typography
            textAlign={"right"}
            sx={{
              opacity: "0.5",
            }}
          >
            Last 30 days
          </Typography>
        </Grid>
        <Grid item sm={12} xs={12} md={4}>
          <Card
            style={{
              display: "flex",
              justifyContent: "flex-start",
              alignItems: "center",
            }}
          >
            <Stack
              direction={"row"}
              alignItems={"center"}
              justifyContent={"center"}
              gap={"60px"}
              flexWrap={"wrap"}
            >
              <Box>
                <NoteAddIcon
                  color="primary"
                  sx={{
                    fontSize: "80px",
                    border: "1px solid #eceef0",
                    borderRadius: "50%",
                    padding: "20px",
                  }}
                />
              </Box>
              <Box>
                <Typography>Today's Orders</Typography>
                <Typography textAlign={"center"} fontWeight={600} fontSize={20}>
                  {dashboardData?.todays_shipments}
                </Typography>
              </Box>
            </Stack>
          </Card>
        </Grid>
        <Grid item sm={12} xs={12} md={4}>
          <Card
            style={{
              display: "flex",
              justifyContent: "flex-start",
              alignItems: "center",
            }}
          >
            <Stack
              direction={"row"}
              alignItems={"center"}
              justifyContent={"center"}
              gap={"60px"}
              flexWrap={"wrap"}
            >
              <Box>
                <AccountBalanceWallet
                  color="primary"
                  sx={{
                    fontSize: "80px",
                    border: "1px solid #eceef0",
                    borderRadius: "50%",
                    padding: "20px",
                  }}
                />
              </Box>
              <Box>
                <Typography>Today's Revenue</Typography>
                <Typography textAlign={"center"} fontWeight={600} fontSize={20}>
                  Rs {dashboardData?.todays_revenue ?? 0}
                </Typography>
              </Box>
            </Stack>
          </Card>
        </Grid>
        <Grid item sm={12} xs={12} md={4}>
          <Card
            style={{
              display: "flex",
              justifyContent: "flex-start",
              alignItems: "center",
            }}
          >
            <Stack
              direction={"row"}
              alignItems={"center"}
              gap={"60px"}
              justifyContent={"center"}
              flexWrap={"wrap"}
            >
              <Box>
                <LocalShippingSharp
                  color="primary"
                  sx={{
                    fontSize: "80px",
                    border: "1px solid #eceef0",
                    borderRadius: "50%",
                    padding: "20px",
                  }}
                />
              </Box>
              <Box>
                <Typography>Average Shipping</Typography>
                <Typography textAlign={"center"} fontWeight={600} fontSize={20}>
                  Rs {dashboardData?.average_shipping ?? 0}
                </Typography>
              </Box>
            </Stack>
          </Card>
        </Grid>
        <Grid item sm={12} xs={12} md={12}>
          <Card>
            <Grid container spacing={4}>
              <Grid item xs={12}>
                <Typography>Shipments Details</Typography>
              </Grid>
              <Grid item xs={12} sm={6} md={12 / 6}>
                <Stack justifyContent={"center"} alignItems={"center"}>
                  <SmallBox>
                    {dashboardData?.shipments_details?.total_shipments ?? 0}
                  </SmallBox>
                  <Typography fontSize={12}>Total Shipments</Typography>
                </Stack>
              </Grid>
              <Grid item xs={12} sm={6} md={12 / 6}>
                <Stack justifyContent={"center"} alignItems={"center"}>
                  <SmallBox>
                    {dashboardData?.shipments_details?.pickup_pending ?? 0}
                  </SmallBox>
                  <Typography fontSize={12}>Pickup Pending</Typography>
                </Stack>
              </Grid>
              <Grid item xs={12} sm={6} md={12 / 6}>
                <Stack justifyContent={"center"} alignItems={"center"}>
                  <SmallBox>
                    {dashboardData?.shipments_details?.in_transit ?? 0}
                  </SmallBox>
                  <Typography fontSize={12}>In-Transit</Typography>
                </Stack>
              </Grid>
              <Grid item xs={12} sm={6} md={12 / 6}>
                <Stack justifyContent={"center"} alignItems={"center"}>
                  <SmallBox>
                    {dashboardData?.shipments_details?.exception ?? 0}
                  </SmallBox>
                  <Typography fontSize={12}>Exception</Typography>
                </Stack>
              </Grid>

              <Grid item xs={12} sm={6} md={12 / 6}>
                <Stack justifyContent={"center"} alignItems={"center"}>
                  <SmallBox>
                    {dashboardData?.shipments_details?.delivered ?? 0}
                  </SmallBox>
                  <Typography fontSize={12}>Delivered</Typography>
                </Stack>
              </Grid>

              <Grid item xs={12} sm={6} md={12 / 6}>
                <Stack justifyContent={"center"} alignItems={"center"}>
                  <SmallBox>
                    {dashboardData?.shipments_details.rto ?? 0}
                  </SmallBox>
                  <Typography fontSize={12}>RTO</Typography>
                </Stack>
              </Grid>
            </Grid>
          </Card>
        </Grid>
        <Grid item sm={12} xs={12} md={12}>
          <Card>
            <Grid container spacing={4}>
              <Grid item xs={12}>
                <Typography>NDR Details</Typography>
              </Grid>
              <Grid item xs={12} sm={6} md={3}>
                <Stack justifyContent={"center"} alignItems={"center"}>
                  <SmallBox>0</SmallBox>
                  <Typography fontSize={12}>Total NDR</Typography>
                </Stack>
              </Grid>
              <Grid item xs={12} sm={6} md={3}>
                <Stack justifyContent={"center"} alignItems={"center"}>
                  <SmallBox>0</SmallBox>
                  <Typography fontSize={12}>Your Reattempt Request</Typography>
                </Stack>
              </Grid>
              <Grid item xs={12} sm={6} md={3}>
                <Stack justifyContent={"center"} alignItems={"center"}>
                  <SmallBox>0</SmallBox>
                  <Typography fontSize={12}>Buyer Reattempt Request</Typography>
                </Stack>
              </Grid>
              <Grid item xs={12} sm={6} md={3}>
                <Stack justifyContent={"center"} alignItems={"center"}>
                  <SmallBox>1</SmallBox>
                  <Typography fontSize={12}>NDR Delivered</Typography>
                </Stack>
              </Grid>
            </Grid>
          </Card>
        </Grid>
        <Grid item sm={12} xs={12} md={12}>
          <Card>
            <Grid container spacing={4}>
              <Grid item xs={12}>
                <Typography>COD Status</Typography>
              </Grid>

              <Grid item sm={6} xs={12} md={4}>
                <Stack justifyContent={"center"} alignItems={"center"}>
                  <SmallBox>
                    {dashboardData?.cod_status.total_cod ?? 0}
                  </SmallBox>
                  <Typography fontSize={12}>Total COD</Typography>
                </Stack>
              </Grid>
              <Grid item sm={6} xs={12} md={4}>
                <Stack justifyContent={"center"} alignItems={"center"}>
                  <SmallBox>
                    {dashboardData?.cod_status.cod_pending ?? 0}
                  </SmallBox>
                  <Typography fontSize={12}>COD Pending</Typography>
                </Stack>
              </Grid>
              <Grid item sm={6} xs={12} md={4}>
                <Stack justifyContent={"center"} alignItems={"center"}>
                  <SmallBox>
                    {dashboardData?.cod_status.cod_remitted ?? 0}
                  </SmallBox>
                  <Typography fontSize={12}>Last COD Remitted</Typography>
                </Stack>
              </Grid>
            </Grid>
          </Card>
        </Grid>

        <Grid item xs={12}>
          <Card
            style={{
              overflowX: "hidden",
            }}
          >
            <TableContainer>
              <Table aria-label="simple table">
                <TableHead>
                  <TableRow>
                    <TableCell sx={tableCellStyle}>Service</TableCell>
                    <TableCell sx={tableCellStyle}>
                      Pickup Unscheduled
                    </TableCell>
                    <TableCell sx={tableCellStyle}>Booking Pending</TableCell>
                    <TableCell sx={tableCellStyle}>Pickup Scheduled</TableCell>
                    <TableCell sx={tableCellStyle}>In Transit</TableCell>
                    <TableCell sx={tableCellStyle}>Exception</TableCell>
                    <TableCell sx={tableCellStyle}>Delivered</TableCell>
                    <TableCell sx={tableCellStyle}>RTO</TableCell>
                    <TableCell sx={tableCellStyle}>Total Shipments</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {dashboardData &&
                    dashboardData?.shipments_by_service.map((el, index) => {
                      return (
                        <TableRow>
                          <TableCell sx={tableCellStyle}>
                            {el.service}
                             {/* {localStorage.getItem("hipship-username") === "Cipla" ? "hipship" : el.service} */}
                          </TableCell>
                          <TableCell sx={tableCellStyle}>
                            {el.pickup_unscheduled}
                          </TableCell>
                          <TableCell sx={tableCellStyle}>
                            {el.booking_pending}
                          </TableCell>
                          <TableCell sx={tableCellStyle}>
                            {el.pickup_scheduled}
                          </TableCell>
                          <TableCell sx={tableCellStyle}>
                            {el.in_transit}
                          </TableCell>
                          <TableCell sx={tableCellStyle}>
                            {el.exception}
                          </TableCell>
                          <TableCell sx={tableCellStyle}>
                            {el.delivered}
                          </TableCell>
                          <TableCell sx={tableCellStyle}>{el.rto}</TableCell>
                          <TableCell sx={tableCellStyle}>
                            {el.total_shipments}
                          </TableCell>
                        </TableRow>
                      );
                    })}
                </TableBody>
              </Table>
              <NoDataFound data={dashboardData?.shipments_by_service ?? []} />
            </TableContainer>
          </Card>
        </Grid>
      </Grid>
    </>
  );
};

export default Overview;
